<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />

</svelte:head>

<script>

    import {getContext, onMount} from "svelte";

    import {
        errorReasons,
        updateUserStatus,
        dataAvailable, logout
    } from "../api.svelte";

    import {
        getLocalSessionId,
        getLocalUserStatus,
        getStatusRoute, sessionCleanup
    } from "../../utils/session";
    import {sessionId} from "../../utils/store";


    const REFRESH_INTERVAL = 5000;


    const router = getContext('router');

    let propertyId = localStorage.getItem('kpropertyid');

    let refreshTimer = null;
    let isMobile = false;


    onMount(() => {

        let localSessionId = getLocalSessionId();
        let localStatus = getLocalUserStatus();

        if (!localSessionId || !localStatus) {

            router.route('/login');
            return;

        }

        if (localStatus !== 'onboarding_collecting') {

            router.route(getStatusRoute(localStatus));
            return;

        }

        isMobile = checkDeviceSize();

        if (!isMobile) {

            startRefreshTimer();

            refresh();

        }

    });

    let checkDeviceSize = () => {

        return window.matchMedia('screen and (max-width: 1024px)').matches;
    }

    let startRefreshTimer = () => {

        if (refreshTimer) {

            return;
        }

        refreshTimer = setInterval(() => {

            refresh();

        }, REFRESH_INTERVAL);

    };

    let refresh = () => {

        dataAvailable(propertyId, 'dashboard').then((availableResult) => {

            console.log(availableResult);

            if (availableResult['status'] !== 'success') {

                // TODO: Handle errore
                return;

            }

            if (availableResult['hasdata'] === 'yes') {

                onboardingDone();
            }

        });

    };

    let onboardingDone = () => {

        if (refreshTimer) {

            clearInterval(refreshTimer);
        }

        localStorage.setItem('kstatus', 'active');
        updateUserStatus('active');

        router.route('/');

    };

    let logoutHandler = () => {

        logout().then((_) => {

            sessionId.set('');
            sessionCleanup();
            router.route('/login');

        });

    };

</script>


<div class="onboarding-logout" on:click={() => logoutHandler()}>

    <img src="/images/icons/nav/logout.svg" alt="" />
    <span>Logout</span>

</div>

{#if !isMobile}

    <div class="onboarding-container">

        <div class="onboarding-text">

            <div class="headline-styler"></div>

            <h2>
                Ihre Bewertungen werden
                gesammelt und analysiert.
            </h2>

            <ul class="keyosh-list">

                <li>
                    Dieser Vorgang kann bis zu 15 Minuten dauern,
                    Sie werden danach weitergeleitet.
                </li>

            </ul>

        </div>

        <div class="onboarding-animation">

            <video src="/animations/keyosh3_4.mp4" autoplay muted playsinline loop></video>
        </div>

    </div>



{:else}

    <div class="onboarding-text">

        <div class="headline-styler"></div>

        <h2>
            Ihre Bewertungen werden
            gesammelt und analysiert.
        </h2>

        <ul class="keyosh-list">

            <li>
                Bitte fahren Sie auf Ihrem Laptop oder Computer weiter.
            </li>

        </ul>

    </div>

{/if}


<style>

    /**/

    .onboarding-container {
        display: flex;
        flex-direction: row;
        width: 140vh;
        max-width: 96vw;
        justify-content: space-evenly;
    }

    .onboarding-animation {
        max-width: 47vw;
        width: 46vh;
    }

    .onboarding-animation video {
        width: 100%;
        height: auto;
    }

</style>
